module.exports = __webpack_public_path__ + "img/notary-journal_B09JR5YNQD.073414ca.jpg";